"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatrixData = exports.MatrixCellFtEntry = exports.MatrixRowElement = exports.CellValue = exports.HighlightingMode = exports.CellSelectionMode = exports.RowClickMode = exports.ColumnClickMode = exports.MatrixColumnWidth = exports.MatrixHeaderSize = void 0;
/// <reference path="./Matrix.d.ts" />
require("@progress/kendo-ui");
require("babel-polyfill");
require("handsontable");
require("handsontable/dist/handsontable.full.css");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.min.css");
const Utilities_1 = require("../../javascript/Utilities");
const synerisMethods_1 = require("../Menu/synerisMethods");
require("./Matrix.less");
const $ = require("jquery");
const _ = require("underscore");
/**
* Must match LESS size definitions in Matrix.less
*/
var MatrixHeaderSize;
(function (MatrixHeaderSize) {
    MatrixHeaderSize[MatrixHeaderSize["Small"] = 125] = "Small";
    MatrixHeaderSize[MatrixHeaderSize["Medium"] = 200] = "Medium";
    MatrixHeaderSize[MatrixHeaderSize["Large"] = 400] = "Large";
})(MatrixHeaderSize = exports.MatrixHeaderSize || (exports.MatrixHeaderSize = {}));
/**
* Must match LESS size definitions in Matrix.less
*/
var MatrixColumnWidth;
(function (MatrixColumnWidth) {
    MatrixColumnWidth[MatrixColumnWidth["Small"] = 32] = "Small";
    MatrixColumnWidth[MatrixColumnWidth["Medium"] = 64] = "Medium";
    MatrixColumnWidth[MatrixColumnWidth["Large"] = 128] = "Large";
    MatrixColumnWidth[MatrixColumnWidth["Huge"] = 256] = "Huge";
})(MatrixColumnWidth = exports.MatrixColumnWidth || (exports.MatrixColumnWidth = {}));
var CellHighlightReason;
(function (CellHighlightReason) {
    CellHighlightReason[CellHighlightReason["SelectionOrHover"] = 1] = "SelectionOrHover";
    CellHighlightReason[CellHighlightReason["RowOrColumnSearch"] = 2] = "RowOrColumnSearch";
})(CellHighlightReason || (CellHighlightReason = {}));
/**
* Click mode for columns.
*/
var ColumnClickMode;
(function (ColumnClickMode) {
    /**
    * No column selection
    */
    ColumnClickMode[ColumnClickMode["None"] = 0] = "None";
    /**
   * Column instance is opened in property page in a new tab.
   */
    ColumnClickMode[ColumnClickMode["Properties"] = 1] = "Properties";
    /**
    * Column click mode.
    * Only columns containing at least one cell with a non-undefined value are selectable
    * Only relevant for READONLY matrices!
    */
    ColumnClickMode[ColumnClickMode["ColSelection_All"] = 2] = "ColSelection_All";
    /**
    * A callback function is called upon column click.
    */
    ColumnClickMode[ColumnClickMode["Callback"] = 3] = "Callback";
})(ColumnClickMode = exports.ColumnClickMode || (exports.ColumnClickMode = {}));
/**
* Click mode for rows.
*/
var RowClickMode;
(function (RowClickMode) {
    /**
    * No row click handling
    */
    RowClickMode[RowClickMode["None"] = 0] = "None";
    /**
    * Row instance is opened in property page in a new tab.
    */
    RowClickMode[RowClickMode["Properties"] = 1] = "Properties";
    /**
    * Row selection mode.
    * Only rows representing leaves in the user hierarchy and containing at least one cell with a non-undefined value are selectable.
    * Only relevant for READONLY matrices!
    */
    RowClickMode[RowClickMode["RowSelection_OnlyLeaves"] = 2] = "RowSelection_OnlyLeaves";
    /**
    * Row selection mode.
    * Only rows containing at least one cell with a non-undefined value are selectable
    * Only relevant for READONLY matrices!
    */
    RowClickMode[RowClickMode["RowSelection_All"] = 3] = "RowSelection_All";
    /**
   * A callback function is called upon row click.
   */
    RowClickMode[RowClickMode["Callback"] = 4] = "Callback";
})(RowClickMode = exports.RowClickMode || (exports.RowClickMode = {}));
/**
* Selection mode for cells
*/
var CellSelectionMode;
(function (CellSelectionMode) {
    /**
    * No selection
    */
    CellSelectionMode[CellSelectionMode["None"] = 0] = "None";
    /**
    * Directly select cells
    */
    CellSelectionMode[CellSelectionMode["Direct"] = 1] = "Direct";
    /**
    * Hierarchical cells select children
    */
    CellSelectionMode[CellSelectionMode["Inherit"] = 2] = "Inherit";
})(CellSelectionMode = exports.CellSelectionMode || (exports.CellSelectionMode = {}));
/**
* How highlighting behaves
*/
var HighlightingMode;
(function (HighlightingMode) {
    /**
    * No highlighting
    */
    HighlightingMode[HighlightingMode["None"] = 0] = "None";
    /**
    * Only the cell's column header and row header are highlighted
    */
    HighlightingMode[HighlightingMode["OnlyHeaders"] = 1] = "OnlyHeaders";
    /**
    * The cell's entire row and column (including headers) are highlighted
    */
    HighlightingMode[HighlightingMode["Full"] = 2] = "Full";
})(HighlightingMode = exports.HighlightingMode || (exports.HighlightingMode = {}));
class RefCountObject {
    constructor() {
        this.refCount = 0;
    }
}
/**
* Helper class for matrix columns
*/
class MatrixColumnElement {
    constructor(id, name, tags) {
        this.id = id;
        this.name = name;
        this.tags = tags;
        this.visible = true;
        this.selectable = false;
        this.clickable = false;
        this.allCellValues = [];
    }
    get isSelected() {
        if (!this.selectable)
            return false;
        for (let i = 0; i < this.allCellValues.length; ++i) {
            const cell = this.allCellValues[i];
            if ((cell === null || cell === void 0 ? void 0 : cell.value) && !cell.isSelected)
                return false;
        }
        return true;
    }
}
class CellValue {
}
exports.CellValue = CellValue;
/**
* Helper class for matrix rows
*/
class MatrixRowElement {
    constructor(id, name) {
        this.id = id;
        this.name = name;
        this.icon = "transparent";
        this.children = [];
        this.values = {};
        this.deleted = false;
        this.expanded = true;
        this.lastClicked = false;
        this.isRoot = false;
        this.isLeaf = false;
        this.isOrgNode = false;
        this.parent = undefined;
        this.hasChildren = false;
        this.hasSuccessors = false; // siblings after self
        this.selectable = false;
        this.clickable = false;
    }
    /**
    * Structurally unique id. Leaf items may be duplicates, this id will be of the form <rowId>|<parentPath>,
    * where <parentPath> contains a |-concatenated list of all parents up to the root.
    */
    get structurallyUniqueId() {
        let parentPathString = "";
        if (this.parentPath != undefined)
            parentPathString = this.parentPath.join("|");
        let suid = this.id.toString();
        if (parentPathString.length > 0)
            suid += "|" + parentPathString;
        return suid;
    }
    get clone() {
        const newClone = new MatrixRowElement(this.id, this.name);
        newClone.icon = this.icon;
        newClone.children = this.children;
        newClone.values = this.values;
        newClone.deleted = this.deleted;
        newClone.expanded = this.expanded;
        newClone.lastClicked = this.lastClicked;
        newClone.isRoot = this.isRoot;
        newClone.isLeaf = this.isLeaf;
        newClone.isOrgNode = this.isOrgNode;
        newClone.parent = this.parent;
        newClone.hasChildren = this.hasChildren;
        newClone.hasSuccessors = this.hasSuccessors;
        newClone.selectable = this.selectable;
        newClone.clickable = this.clickable;
        return newClone;
    }
    /**
    * Hierarchical direct and indirect children
    */
    get recursiveChildren() {
        const result = [];
        const queue = [];
        for (const rowElem of this.children)
            queue.push(rowElem);
        while (queue.length !== 0) {
            const cur = queue.shift();
            if (cur) {
                result.push(cur);
                for (const child of cur.children)
                    queue.push(child);
            }
        }
        return result;
    }
    /**
    * Whether the row element is selected or not
    */
    get isSelected() {
        if (!this.selectable || !this.hasValues)
            return false;
        for (const prop in this.values) {
            const cell = this.values[prop];
            if ((cell === null || cell === void 0 ? void 0 : cell.value) && !cell.isSelected)
                return false;
        }
        return true;
    }
    /**
    * Returns true if at least one non-undefined value exists for this row.
    */
    get hasValues() {
        for (const prop in this.values) {
            const cellVal = this.values[prop];
            if ((cellVal === null || cellVal === void 0 ? void 0 : cellVal.value) != undefined)
                return true;
        }
        return false;
    }
    get nestingDepth() {
        if (!this.parentPath)
            return 0;
        return this.parentPath.length;
    }
}
exports.MatrixRowElement = MatrixRowElement;
class ServerMatrixRowData {
}
class MatrixCellFtEntry {
}
exports.MatrixCellFtEntry = MatrixCellFtEntry;
class MatrixData {
    //#region CONSTRUCTOR
    constructor(columns, roots, cellType, cellFtValues) {
        const that = this;
        that.m_requestCount = 0;
        that.columns = columns;
        that.roots = roots;
        that.dfsIndexMap = {};
        that.rowIdMap = {};
        that.cellType = cellType || 5 /* Bool*/;
        that.cellFtValues = cellFtValues;
        that.mapIdtoEntry = {};
        if (that.cellFtValues) {
            $.each(that.cellFtValues, (idx, entry) => {
                that.mapIdtoEntry[entry.id] = entry;
            });
        }
        that.columns.sort((c1, c2) => c1.name.localeCompare(c2.name));
        that.buildDfsIndexMap();
        that.rowIdHighlightedForSearch = undefined;
        that.colIdHighlightedForSearch = undefined;
    }
    //#endregion MEMBER VARIABLES
    //#region MEMBER METHODS
    setData(synData, serverData, forColumnId) {
        for (let i = 0; i < serverData.length; ++i) {
            const rowsForId = this.getRowsForRowId(serverData[i].rowId);
            if (!rowsForId)
                continue;
            for (let j = 0; j < rowsForId.length; ++j)
                this.setDataForRow(synData, rowsForId[j], serverData[i], forColumnId);
        }
    }
    getFtEntry(id) {
        return this.mapIdtoEntry[id] || undefined;
    }
    setDataForRow(synData, row, serverData, forColumnId) {
        row.deleted = serverData.deleted;
        row.allowRead = serverData.allowRead;
        row.allowWrite = !row.abstract && serverData.allowWrite;
        if (forColumnId == undefined)
            row.values = {};
        const forColumnIdString = forColumnId == undefined ? undefined : forColumnId.toString();
        for (const prop in serverData.values) {
            if (forColumnIdString != undefined && prop !== forColumnIdString)
                continue;
            const cellValue = serverData.values[prop] ? $.extend({}, serverData.values[prop]) : undefined;
            if (cellValue) {
                cellValue.isSelected = false;
                cellValue.selectable = synData.cellSelectionMode !== CellSelectionMode.None;
                row.values[prop] = cellValue;
            }
        }
    }
    getColumnForId(colId) {
        for (let idx = 0; idx < this.columns.length; ++idx)
            if (this.columns[idx].id === colId)
                return this.columns[idx];
        return undefined;
    }
    getColumnIndexForId(colId) {
        for (let idx = 0; idx < this.columns.length; ++idx)
            if (this.columns[idx].id === colId)
                return idx;
        return -1;
    }
    /**
    * For a row specified rowId, returns all rows that are either equal to that row, or
    * are hierarchical parent or child rows of that row. For precence reasons, siblings
    * (parents of children or children of parents) are added as well.
    */
    getEnvironmentForRowId(rowId) {
        const mapRelevantIds = {};
        const nodeQueue = [];
        const rowIndexes = this.getRowIndexesForId(rowId);
        for (let i = 0; i < rowIndexes.length; ++i)
            nodeQueue.splice(0, 0, this.dfsIndexMap[rowIndexes[i].toString()]);
        while (nodeQueue.length > 0) {
            const curNode = nodeQueue.pop();
            if (curNode && !mapRelevantIds[curNode.id]) {
                for (let i = 0; i < curNode.children.length; ++i)
                    nodeQueue.push(curNode.children[i]);
                if (curNode.parent)
                    nodeQueue.push(curNode.parent);
                mapRelevantIds[curNode.id] = true;
            }
        }
        return $.map(Object.keys(mapRelevantIds), prop => parseInt(prop, 10));
    }
    /**
     * Returns the physical row indexes for all rows with a given rowId, regardless of whether they are currently visible or not.
     * @param rowId
     */
    getRowIndexesForId(rowId) {
        const rowIndexes = [];
        for (const prop in this.dfsIndexMap)
            if (this.dfsIndexMap[prop].id === rowId)
                rowIndexes.push(parseInt(prop, 10));
        return rowIndexes;
    }
    getRowsForRowId(rowId) {
        const arr = this.rowIdMap[rowId];
        if (!arr)
            return [];
        return arr.slice();
    }
    getRowIds() {
        const mapIds = {};
        for (let i = 0; i < this.rowCount; ++i)
            mapIds[this.dfsIndexMap[i].id] = true;
        return $.map(Object.keys(mapIds), (idString) => parseInt(idString, 10));
    }
    getDataAtCell(rowIndex, columnIndex) {
        const row = this.dfsIndexMap[rowIndex];
        return row.values[this.columns[columnIndex].id] || undefined;
    }
    /**
     * Returns this matrix as tabular data such that Handsontable can use it as data source
     */
    getTabularData() {
        const tabularData = [];
        for (let i = 0; i < this.rowCount; ++i) {
            const curRowElem = this.dfsIndexMap[i];
            tabularData[i] = [];
            for (let j = 0; j < this.columns.length; ++j) {
                const colId = this.columns[j].id;
                tabularData[i][j] = curRowElem.values[colId] || undefined;
            }
            // pseudo column for rendering purposes
            tabularData[i][this.columns.length] = undefined;
        }
        return tabularData;
    }
    // [[rowIdx, colIdx, CellValue], ...]
    getUpdateData(handsonTableInstance, forRowIds, forColumnId) {
        const updateData = [];
        for (let i = 0; i < this.columns.length; ++i) {
            const visualColIdx = handsonTableInstance.toVisualColumn(i);
            const column = this.columns[i];
            if (visualColIdx != undefined && ((forColumnId == undefined) || column.id === forColumnId)) {
                for (let j = 0; j < this.rowCount; ++j) {
                    const row = this.dfsIndexMap[j];
                    const visualRowIdx = handsonTableInstance.toVisualRow(j);
                    if (visualRowIdx == undefined)
                        continue;
                    if (forRowIds != undefined && $.inArray(row.id, forRowIds) < 0)
                        continue;
                    updateData.push([visualRowIdx, visualColIdx, row.values[column.id] || undefined]);
                }
            }
        }
        return updateData;
    }
    /**
    * Comparison function that (within an level) places user nodes before organizational nodes and
    * then sorts both groups alphabetically.
    */
    static orgNodeComparisonFunc(a, b) {
        let result = 0;
        if (a.isOrgNode) {
            if (b.isOrgNode)
                result = 0;
            else
                result = 1;
        }
        else if (b.isOrgNode)
            result = -1;
        else
            result = 0;
        if (result === 0)
            return a.name.localeCompare(b.name);
        return result;
    }
    /**
    * Builds row indexes in depth-first order of the user hierarchy, as well as parent-child lookups etc.
    */
    buildDfsIndexMap() {
        const curDfsIdx = { idx: 0 };
        this.roots.sort(MatrixData.orgNodeComparisonFunc);
        for (let i = 0; i < this.roots.length; i++) {
            this.roots[i].hasChildren = this.roots[i].children.length !== 0;
            this.roots[i].isLeaf = !this.roots[i].hasChildren;
            this.roots[i].isRoot = true;
            this.roots[i].hasSuccessors = i < this.roots.length - 1;
            this.buildDfsIndexMapRecursive(this.roots[i], curDfsIdx);
        }
        this.rowCount = curDfsIdx.idx;
    }
    buildDfsIndexMapRecursive(curElem, curDfsIdx) {
        this.dfsIndexMap[curDfsIdx.idx++] = curElem;
        if (!this.rowIdMap[curElem.id])
            this.rowIdMap[curElem.id] = [];
        this.rowIdMap[curElem.id].push(curElem);
        curElem.children.sort(MatrixData.orgNodeComparisonFunc);
        for (let i = 0; i < curElem.children.length; i++) {
            curElem.children[i].hasSuccessors = i < curElem.children.length - 1;
            curElem.children[i].hasChildren = curElem.children[i].children.length !== 0;
            curElem.children[i].isLeaf = !curElem.children[i].hasChildren;
            curElem.children[i].isRoot = false;
            this.buildDfsIndexMapRecursive(curElem.children[i], curDfsIdx);
        }
    }
    beginRequest() {
        ++this.m_requestCount;
    }
    endRequest() {
        --this.m_requestCount;
    }
    get requestInProgress() {
        return this.m_requestCount > 0;
    }
}
exports.MatrixData = MatrixData;
class Matrix {
    static init($target, options) {
        return $target.each(function () {
            const $this = $(this);
            const synData = $this.data("synMatrix");
            if (!synData) {
                $this.data("synMatrix", $.extend({
                    width: 600,
                    height: 400,
                    colHeaderSize: MatrixHeaderSize.Medium,
                    rowHeaderSize: MatrixHeaderSize.Medium,
                    colWidth: MatrixColumnWidth.Small,
                    initiallySelectedTag: "",
                    rowClickMode: RowClickMode.None,
                    colClickMode: ColumnClickMode.None,
                    cellSelectionMode: CellSelectionMode.None,
                    hoverHighlightingMode: HighlightingMode.OnlyHeaders,
                    expandAllNodes: false,
                    columnFilterPredicate: (col, srvData) => true
                }, options));
                $this.trigger("beginInit");
                $this.html("")
                    .addClass("synMatrix")
                    .css({
                    "width": options.width.toString() + "px",
                    "height": options.height.toString() + "px"
                });
                if (kendo.support.browser.msie && "11" === kendo.support.browser.version.toString())
                    if (navigator && navigator.appVersion && navigator.appVersion.indexOf("Windows NT 6.1") > 0)
                        $this.addClass("win7_ie11_fix");
                const $fieldPane = $("<div class='fieldPane uninitialized'></div>")
                    .addClass("rowHeader-" + MatrixHeaderSize[options.rowHeaderSize || MatrixHeaderSize.Medium].toLowerCase())
                    .appendTo($this);
                $fieldPane.append("<div class='fieldWrapper'></div>");
                $("<div class='matrixPane'></div>")
                    .addClass("colWidth-" + MatrixColumnWidth[options.colWidth || MatrixColumnWidth.Small].toLowerCase()
                    + " colHeader-" + MatrixHeaderSize[options.colHeaderSize || MatrixHeaderSize.Medium].toLowerCase()
                    + " rowHeader-" + MatrixHeaderSize[options.rowHeaderSize || MatrixHeaderSize.Medium].toLowerCase())
                    .appendTo($this);
                Matrix.InitCore($this);
                $this.trigger("endInit");
            }
        });
    }
    static destroy($target) {
        return $target.each(function () {
            $(this).off("beginInit")
                .off("categoriesReceived")
                .off("initSuccess")
                .off("initFailed")
                .off("structureReceived")
                .off("dataReceived")
                .off("endInit")
                .off("categorySelected")
                .removeData("synMatrix");
            const handsonTableInstance = Matrix.getHandsonTableInstance($(this));
            if (handsonTableInstance) {
                handsonTableInstance.destroy();
                $target.children(".matrixPane").data("handsontable", undefined);
            }
            $(this).html("");
        });
    }
    static resize($this, newWidth, newHeight) {
        const hotInstance = Matrix.getHandsonTableInstance($this);
        const matrixHeight = Math.max(0, newHeight - $this.children(".fieldPane").outerHeight(true));
        if (hotInstance) {
            hotInstance.updateSettings({
                width: newWidth,
                height: matrixHeight
            });
        }
        $this.css({ "width": newWidth + "px", "height": newHeight + "px" });
    }
    static refresh($this) {
        const matrixData = $this.data("matrixData");
        const hot = Matrix.getHandsonTableInstance($this);
        const synData = $this.data("synMatrix");
        if (matrixData && hot) {
            Matrix.fetchMatrixData($this, matrixData.matrixId, matrixData, undefined, undefined, undefined, synData.contextInformation, (data) => {
                Matrix.setServerData($this, data, matrixData);
                hot.updateSettings({
                    data: matrixData.getTabularData(),
                });
                hot.render();
            });
        }
    }
    static getTags($this) {
        const matrixData = $this.data("matrixData");
        return matrixData.allTags;
    }
    static getSelection($this) {
        const selObj = {};
        const synData = $this.data("synMatrix");
        const matrixData = $this.data("matrixData");
        const colIds = $.map(matrixData.columns, (col) => col.id);
        const rowIds = matrixData.getRowIds();
        for (let i = 0; i < rowIds.length; ++i) {
            const rowId = rowIds[i];
            const row = matrixData.getRowsForRowId(rowId)[0];
            for (let j = 0; j < colIds.length; ++j) {
                let add = false;
                const col = matrixData.getColumnForId(colIds[j]);
                if (col) {
                    const cell = row.values[col.id];
                    const cellHasValue = cell && cell.value != undefined;
                    if (row.isSelected)
                        add = synData.rowClickMode !== RowClickMode.RowSelection_All || cellHasValue;
                    if (!add && col.isSelected)
                        add = synData.colClickMode !== ColumnClickMode.ColSelection_All || cellHasValue;
                    if (cell === null || cell === void 0 ? void 0 : cell.isSelected)
                        add = true;
                    if (add) {
                        if (!selObj[rowId])
                            selObj[rowId] = [];
                        selObj[rowId].push(col.id);
                    }
                }
            }
        }
        return selObj;
    }
    //#region Helpers
    static toggleRowSelection($this, matrixData, physicalRowIdx) {
        let selectionChanged = false;
        const thisRow = matrixData.dfsIndexMap[physicalRowIdx];
        if (thisRow.selectable) {
            const clonedRows = matrixData.getRowsForRowId(thisRow.id);
            let currentlySelected = false;
            for (const prop in clonedRows[0].values) {
                const cell = clonedRows[0].values[prop];
                if (cell === null || cell === void 0 ? void 0 : cell.value) {
                    if (currentlySelected === false)
                        currentlySelected = cell.isSelected;
                    cell.isSelected = !currentlySelected;
                    for (let i = 1; i < clonedRows.length; ++i)
                        clonedRows[i].values[prop].isSelected = cell.isSelected;
                    selectionChanged = true;
                }
            }
        }
        return selectionChanged;
    }
    static toggleColumnSelection($this, matrixData, physicalColIdx) {
        let selectionChanged = false;
        const col = matrixData.columns[physicalColIdx];
        if (col.selectable) {
            let currentlySelected = false;
            for (let i = 0; i < matrixData.rowCount; ++i) {
                const row = matrixData.dfsIndexMap[i];
                const cell = row.values[col.id];
                if (cell === null || cell === void 0 ? void 0 : cell.value) {
                    if (currentlySelected === false)
                        currentlySelected = cell.isSelected;
                    cell.isSelected = !currentlySelected;
                    selectionChanged = true;
                }
            }
        }
        return selectionChanged;
    }
    static toggleCellSelection($this, matrixData, physicalRowIdx, physicalColIdx) {
        const synData = $this.data("synMatrix");
        const thisRow = matrixData.dfsIndexMap[physicalRowIdx];
        let affectedRows = [];
        if (synData.cellSelectionMode === CellSelectionMode.Direct) {
            affectedRows = matrixData.getRowsForRowId(thisRow.id);
            return Matrix.toggleCellSelectionDirect($this, matrixData, physicalRowIdx, physicalColIdx);
        }
        else if (synData.cellSelectionMode === CellSelectionMode.Inherit)
            return Matrix.toggleCellSelectionInherit($this, matrixData, physicalRowIdx, physicalColIdx);
        return false;
    }
    static toggleCellSelectionDirect($this, matrixData, physicalRowIdx, physicalColIdx) {
        const affectedRows = matrixData.getRowsForRowId(matrixData.dfsIndexMap[physicalRowIdx].id);
        const colId = matrixData.columns[physicalColIdx].id;
        let selectionChanged = false;
        const cell = affectedRows[0].values[colId];
        if ((cell === null || cell === void 0 ? void 0 : cell.value) && cell.selectable) {
            cell.isSelected = !cell.isSelected;
            for (let i = 1; i < affectedRows.length; ++i)
                if (affectedRows[i].values[colId])
                    affectedRows[i].values[colId].isSelected = cell.isSelected;
            selectionChanged = true;
        }
        return selectionChanged;
    }
    static toggleCellSelectionInherit($this, matrixData, physicalRowIdx, physicalColIdx) {
        const thisRow = matrixData.dfsIndexMap[physicalRowIdx];
        const colId = matrixData.columns[physicalColIdx].id;
        if (!thisRow.hasChildren)
            return Matrix.toggleCellSelectionDirect($this, matrixData, physicalRowIdx, physicalColIdx);
        const affectedRows = [thisRow];
        for (const recChild of thisRow.recursiveChildren)
            affectedRows.push(recChild);
        // For all leaf rows, add duplicate rows that are not yet part of array
        const mapStructuralId = {};
        for (const row of affectedRows)
            if (row.isLeaf)
                mapStructuralId[row.structurallyUniqueId] = true;
        for (const row of affectedRows) {
            if (row.isLeaf) {
                for (const rowForId of matrixData.getRowsForRowId(row.id)) {
                    if (!mapStructuralId[rowForId.structurallyUniqueId]) {
                        affectedRows.push(rowForId);
                        mapStructuralId[rowForId.structurallyUniqueId] = true;
                    }
                }
            }
        }
        let selectionChanged = false;
        let selectionCandidateCell;
        for (let i = 0; i < affectedRows.length; ++i) {
            const cell = affectedRows[i].values[colId];
            if ((cell === null || cell === void 0 ? void 0 : cell.value) && cell.selectable) {
                selectionCandidateCell = cell;
                break;
            }
        }
        if (selectionCandidateCell != undefined) {
            const newSelectionValue = !selectionCandidateCell.isSelected;
            for (let i = 0; i < affectedRows.length; ++i) {
                const curCell = affectedRows[i].values[colId];
                if ((curCell === null || curCell === void 0 ? void 0 : curCell.value) && curCell.selectable)
                    curCell.isSelected = newSelectionValue;
            }
            selectionChanged = true;
        }
        return selectionChanged;
    }
    // Attempts <stringValue>.<matrixId>, falls back to <stringValue>
    static getMatrixStringValue(stringValue, matrixId) {
        return Utilities_1.synUtil.Strings.getValue(stringValue + "." + matrixId, Utilities_1.synUtil.Strings.getValue(stringValue));
    }
    static getNewCellValue(currentValue, matrixData, callback) {
        if (matrixData.cellType === 10 /*FT*/) {
            if (matrixData.cellFtValues.length > 3) {
                const windowData = Matrix.createPickerWindow(currentValue, matrixData, () => {
                    const ddl = $("#" + windowData.windowID).find("input.picker").data("kendoDropDownList");
                    ddl.select(0);
                }, () => {
                    if (!matrixData.requestInProgress) {
                        const ddl = $("#" + windowData.windowID).find("input.picker").data("kendoDropDownList");
                        const val = ddl.dataItem(ddl.select());
                        callback(val.id, currentValue.value === val.id);
                    }
                });
                const $input = $("#" + windowData.windowID).find("input.picker");
                const $clearButton = $("#" + windowData.windowID).find("button.clearButton");
                const ddlTemplate = "<span data-id='#:id#' #if(data.cssClass){#class='matrixCellftValue #:cssClass#'#}#>#if(!data.cssClass && data.icon){#<img style='margin-right: 4px' src='" + Utilities_1.synUtil.getWSUrl("Icon") + "docid=#:icon#/16'>#}##:name##if(!data.cssClass&&!data.icon&&data.id){# (#:id#)#}#</span>";
                const ddl = $input.kendoDropDownList({
                    dataSource: new kendo.data.DataSource({
                        transport: {
                            read(options) {
                                // We have to delay the rendering of the dropdownlist's items to the moment where the last
                                // request (if a request is pending) has been finished.
                                // Otherwise, a situation can exist where two update requests are issued at the same time,
                                // which is not supported.
                                const intervalDurationMillis = 125;
                                const intervalId = setInterval(() => {
                                    if (!matrixData.requestInProgress) {
                                        clearInterval(intervalId);
                                        const dataItems = [];
                                        for (let i = 0; i < matrixData.cellFtValues.length; ++i)
                                            dataItems.push($.extend(true, {}, matrixData.cellFtValues[i]));
                                        dataItems.sort((i1, i2) => i1.name.localeCompare(i2.name));
                                        const noEntry = new MatrixCellFtEntry();
                                        noEntry.id = "";
                                        noEntry.name = "";
                                        dataItems.splice(0, 0, noEntry);
                                        options.success(dataItems);
                                    }
                                }, intervalDurationMillis);
                            }
                        }
                    }),
                    dataBound() {
                        $clearButton.removeClass("k-state-disabled");
                        if (currentValue.value != undefined) {
                            const dataItems = ddl.dataSource.data();
                            for (let i = 0; i < dataItems.length; ++i) {
                                if (dataItems[i].id === currentValue.value) {
                                    ddl.select(i);
                                    break;
                                }
                            }
                        }
                        else
                            ddl.select(0);
                    },
                    template: ddlTemplate,
                    valueTemplate: ddlTemplate
                }).data("kendoDropDownList");
            }
            else {
                let newValue;
                if (currentValue.value == undefined)
                    newValue = matrixData.cellFtValues[0].id;
                else {
                    let idx = -1;
                    for (let i = 0; i < matrixData.cellFtValues.length; ++i) {
                        if (currentValue.value === matrixData.cellFtValues[i].id) {
                            idx = i;
                            break;
                        }
                    }
                    if (idx === -1)
                        newValue = matrixData.cellFtValues[0].id;
                    else if (idx === matrixData.cellFtValues.length - 1)
                        newValue = undefined;
                    else
                        newValue = matrixData.cellFtValues[idx + 1 % matrixData.cellFtValues.length].id;
                }
                callback(newValue, false);
            }
        }
        else if (matrixData.cellType === 5 /*Bool*/) {
            if (currentValue.value == undefined)
                callback(true, false);
            else
                callback(undefined, false);
        }
        else if (matrixData.cellType === 2 /*Digit*/) {
            const windowData = Matrix.createPickerWindow(currentValue, matrixData, () => {
                const tb = $("#" + windowData.windowID).find("input.picker:not(.k-formatted-value)").data("kendoNumericTextBox");
                tb.value();
            }, () => {
                if (!matrixData.requestInProgress) {
                    const tb = $("#" + windowData.windowID).find("input.picker:not(.k-formatted-value)").blur().data("kendoNumericTextBox");
                    const val = tb.value();
                    callback(val, false);
                }
            });
            windowData.beginInit();
            const $clearButton = $("#" + windowData.windowID).find("button.clearButton").hide();
            const $input = $("#" + windowData.windowID)
                .find("input.picker")
                .attr("type", "number")
                .hide();
            const intervalId = setInterval(() => {
                if (!matrixData.requestInProgress) {
                    windowData.endInit();
                    $clearButton.show().removeClass("k-state-disabled");
                    $input.show();
                    if (currentValue.value != undefined)
                        $input.attr("value", currentValue.value.toString());
                    $input.kendoNumericTextBox({ format: "n0", });
                    clearInterval(intervalId);
                }
            }, 125);
        }
        else
            callback(undefined, true);
    }
    static createPickerWindow(currentValue, matrixData, clearValueFunc, closeWindowFunc) {
        let $input;
        const windowData = Utilities_1.synUtil.popupWindow({
            title: Matrix.getMatrixStringValue("matrixentervalue", matrixData.matrixId),
            width: 375,
            height: 45,
            modal: true
        });
        $("#" + windowData.windowID).addClass("matrixFtValuePickerWindow");
        const $deleteButton = $("<button type='button' class='clearButton k-button k-state-disabled'>✗</button>")
            .on("click", () => { clearValueFunc(); })
            .appendTo(windowData.contentDiv);
        $input = $("<input class='picker' />")
            .width(windowData.contentDiv.innerWidth() || 0 - ($deleteButton.outerWidth(true) || 0) - 18)
            .prependTo(windowData.contentDiv);
        $("#" + windowData.windowID).data("kendoWindow").bind("close", closeWindowFunc);
        return windowData;
    }
    static CellChange($this, matrixId, physicalRowIdx, colIdx, matrixData) {
        const curValue = matrixData.getDataAtCell(physicalRowIdx, colIdx);
        if (curValue && curValue.inherited)
            return;
        Matrix.getNewCellValue(curValue, matrixData, (newValue, cancelled) => {
            if (!cancelled) {
                $this.trigger("cellValueChanged");
                Matrix.updateCellValue($this, matrixData, matrixData.dfsIndexMap[physicalRowIdx].id, matrixData.columns[colIdx].id, newValue);
            }
        });
    }
    static InitCore($this) {
        const synData = $this.data("synMatrix");
        Matrix.getMatrix($this, synData.matrixId, synData.initiallySelectedTag, (md) => {
            $this.data("matrixData", md);
            if (!synData.cellRenderFunc) {
                synData.cellRenderFunc = Matrix.GetRenderFunc($this);
                synData.hasCustomCellRenderer = false;
            }
            else
                synData.hasCustomCellRenderer = true;
            Matrix.initMatrix($this, md, synData);
            Matrix.initFieldPane($this);
            $this.trigger("initSuccess");
        });
    }
    static initMatrix($this, md, options) {
        $this.children(".matrixPane").handsontable({
            autoRowSize: true,
            autoColumnSize: true,
            renderAllRows: true,
            viewportColumnRenderingOffset: 2,
            viewportRowRenderingOffset: 10,
            licenseKey: "f2e1a-b4653-e51c3-b4f09-21e40",
            width: options.width,
            height: Math.max(0, options.height - ($this.children(".fieldPane").outerHeight(true) || 0)),
            currentRowClassName: "highlightedRow",
            currentColClassName: "highlightedCol",
            trimRows: true,
            data: md.getTabularData(),
            fixedColumnsLeft: 0,
            colWidths(index) {
                if (index === (Matrix.getMatrixData($this).columns.length))
                    return (options.colHeaderSize + options.colWidth) / Math.SQRT2;
                return options.colWidth;
            },
            rowHeights(index) {
                return Matrix.RowHeight;
            },
            rowHeaderWidth: options.rowHeaderSize,
            columnHeaderHeight: options.colHeaderSize / Math.SQRT2,
            beforeGetCellMeta(r, c, props) {
                props.disableVisualSelection = true;
                props.editor = false;
            },
            afterRender(isForced) {
                Matrix.restoreSearchHighlighting($this);
            },
            afterSelection(r, c, r2, c2) {
                if (r !== r2 || c !== c2)
                    Matrix.getHandsonTableInstance($this).updateSettings({ disableVisualSelection: false });
            },
            afterSelectionEnd(r, c, r2, c2) {
                let select = false;
                const nodeList = document.querySelectorAll(":hover");
                const hotInstance = Matrix.getHandsonTableInstance($this);
                if (!options.hasCustomCellRenderer && nodeList.length) {
                    const tagName = nodeList[nodeList.length - 1].tagName;
                    if (tagName && tagName.toLowerCase() === "td") {
                        if (r === r2 && c === c2) {
                            select = true;
                            const matrixData = Matrix.getMatrixData($this);
                            const rowIdx = hotInstance.toPhysicalRow(r);
                            Matrix.updateSearchBoxPlaceholders($this, matrixData);
                            if (matrixData.dfsIndexMap[rowIdx].allowWrite && !matrixData.readOnly)
                                if (!Matrix.cellHasPendingOperation($this, rowIdx, c))
                                    Matrix.CellChange($this, options.matrixId, rowIdx, c, matrixData);
                            // Check for duplicate rows, select them as well
                            const rowIndexes = matrixData.getRowIndexesForId(matrixData.dfsIndexMap[rowIdx].id);
                            if (rowIndexes.length > 1) {
                                for (const curRowIdx of rowIndexes) {
                                    if (curRowIdx !== rowIdx)
                                        Matrix.highlightCell($this, hotInstance.toVisualRow(curRowIdx), c, false, CellHighlightReason.SelectionOrHover);
                                }
                            }
                        }
                    }
                }
                if (!select)
                    hotInstance.deselectCell();
            },
            beforeOnCellMouseDown(event, coords, TH, blockCalculations) {
                if (typeof event.button !== "undefined" && event.button !== 0)
                    event.stopImmediatePropagation();
                if (coords.col === -1) {
                    if (coords.row >= 0) {
                        const matrixData = Matrix.getMatrixData($this);
                        const hot = Matrix.getHandsonTableInstance($this);
                        if (!$(event.target).is("span.expander")) {
                            hot.deselectCell();
                            return;
                        }
                        const rowElem = matrixData.dfsIndexMap[hot.toPhysicalRow(coords.row)];
                        for (let i = 0; i < matrixData.rowCount; ++i)
                            matrixData.dfsIndexMap[i].lastClicked = matrixData.dfsIndexMap[i] === rowElem;
                        const isExpanded = rowElem.expanded;
                        Matrix.collapseToggleCore($this, matrixData, rowElem, !isExpanded, false);
                        if (!isExpanded && matrixData.heavy && !options.expandAllNodes)
                            Matrix.collapseAllButThis($this, matrixData, [rowElem]);
                        else
                            Matrix.renderWithCollapsedRowState($this, matrixData);
                        hot.deselectCell();
                        // WORKAROUND START - BUG4323: Matrix Zeilenverschiebung
                        let $contentRow = $(hot.getCell(coords.row, 0, false)).closest("tr");
                        let $fixedRow = $contentRow.closest(".synMatrix").find(`.ht_clone_left tbody > tr:nth-child(${coords.row + 1})`);
                        if ($contentRow.length > 0 && $fixedRow.length > 0) {
                            _.debounce(function () {
                                if ($contentRow[0].getBoundingClientRect().top != $fixedRow[0].getBoundingClientRect().top) {
                                    let scrollPane = $contentRow.closest(".synMatrix").find(".wtHolder:first")[0];
                                    scrollPane.scrollBy({
                                        top: 1
                                    });
                                    scrollPane.scrollBy({
                                        top: -1
                                    });
                                }
                            }, 125)();
                        }
                        // WORKAROUND END
                    }
                    else
                        event.stopImmediatePropagation();
                }
            },
            afterOnCellMouseDown(event, coords, TH) {
                const matrixData = Matrix.getMatrixData($this);
                const $realTarget = $(event.target);
                const hot = Matrix.getHandsonTableInstance($this);
                const synData = $this.data("synMatrix");
                if (matrixData.readOnly || synData.rowClickMode === RowClickMode.Properties || synData.colClickMode === ColumnClickMode.Properties) {
                    const physicalRowIdx = hot.toPhysicalRow(coords.row);
                    const physicalColIdx = hot.toPhysicalColumn(coords.col);
                    let selectionChanged = false;
                    if ($realTarget.is("div.matrixNodeText")) {
                        if (options.rowClickMode === RowClickMode.RowSelection_All || options.rowClickMode === RowClickMode.RowSelection_OnlyLeaves)
                            selectionChanged = Matrix.toggleRowSelection($this, matrixData, physicalRowIdx);
                        else if (options.rowClickMode === RowClickMode.Properties) {
                            const rowId = matrixData.dfsIndexMap[physicalRowIdx].id;
                            synerisMethods_1.synerisMethods.cefunc["2"].impl([rowId.toString()], undefined, undefined, undefined, { newWindow: true });
                            hot.deselectCell();
                        }
                        else if (options.rowClickMode === RowClickMode.Callback) {
                            const rowId = matrixData.dfsIndexMap[physicalRowIdx].id;
                            if (options.rowClickCallback) {
                                options.rowClickCallback(rowId, matrixData);
                                hot.render();
                            }
                        }
                    }
                    else if ($realTarget.is("span.clickableCol")) {
                        if (options.colClickMode === ColumnClickMode.ColSelection_All)
                            selectionChanged = Matrix.toggleColumnSelection($this, matrixData, physicalColIdx);
                        else if (options.colClickMode === ColumnClickMode.Properties) {
                            const colId = matrixData.columns[physicalColIdx].id;
                            synerisMethods_1.synerisMethods.cefunc["2"].impl([colId.toString()], undefined, undefined, undefined, { newWindow: true });
                            hot.deselectCell();
                        }
                        else if (options.colClickMode === ColumnClickMode.Callback) {
                            const colId = matrixData.columns[physicalColIdx].id;
                            if (options.colClickCallback) {
                                options.colClickCallback(colId, matrixData);
                                hot.render();
                            }
                        }
                    }
                    else if ((options.cellSelectionMode !== CellSelectionMode.None || options.cellClick) && coords.row >= 0 && coords.col >= 0) {
                        let continueSelect = true;
                        if (options.cellClick) {
                            const rowElem = matrixData.dfsIndexMap[physicalRowIdx];
                            const colElem = matrixData.columns[physicalColIdx];
                            const handlerResult = options.cellClick(rowElem.id, colElem.id, matrixData);
                            if (typeof handlerResult !== "undefined")
                                continueSelect = handlerResult;
                        }
                        if (continueSelect) {
                            if (options.cellSelectionMode !== CellSelectionMode.None)
                                selectionChanged = Matrix.toggleCellSelection($this, matrixData, physicalRowIdx, physicalColIdx);
                        }
                        else
                            hot.render();
                    }
                    if (selectionChanged) {
                        hot.render();
                        $this.trigger("selectionChanged");
                    }
                }
                else if ($(event.target).closest("th").length)
                    hot.deselectCell();
            },
            afterOnCellMouseOver: _.debounce(function (event, coords, TD) {
                if (coords.row >= 0 && coords.col >= 0) {
                    Matrix.unhighlightAll($this, CellHighlightReason.SelectionOrHover);
                    const hot = Matrix.getHandsonTableInstance($this);
                    const matrixData = Matrix.getMatrixData($this);
                    const rowIndexes = matrixData.getRowIndexesForId(matrixData.dfsIndexMap[hot.toPhysicalRow(coords.row)].id);
                    for (const physicalIdx of rowIndexes)
                        Matrix.highlightCell($this, hot.toVisualRow(physicalIdx), coords.col, true, CellHighlightReason.SelectionOrHover);
                }
            }, 10),
            afterOnCellMouseOut: _.debounce(function (event, coords, TD) {
                Matrix.unhighlightCell($this, coords.row, coords.col, CellHighlightReason.SelectionOrHover);
            }, 10),
            renderer(instance, td, row, col, prop, value, cellProperties) {
                const matrixData = Matrix.getMatrixData($this);
                // Pseudo column
                if (col >= matrixData.columns.length)
                    return;
                if (!matrixData.columns[col].visible)
                    return;
                const rowIdx = Matrix.getHandsonTableInstance($this).toPhysicalRow(row);
                const rowElem = matrixData.dfsIndexMap[rowIdx];
                let classesToAdd = "";
                if (rowElem.deleted)
                    classesToAdd += " deleted";
                else {
                    if (value != undefined) {
                        if (value.inherited)
                            classesToAdd += " inherited";
                        if (value.selectable)
                            classesToAdd += " selectable";
                        if (value.isSelected || rowElem.isSelected || matrixData.columns[col].isSelected)
                            classesToAdd += " selected";
                    }
                    else if (!rowElem.isLeaf && options.cellSelectionMode === CellSelectionMode.Inherit)
                        classesToAdd += " recursivelySelectable";
                    if (!rowElem.allowRead)
                        classesToAdd += " noRead";
                    if (!rowElem.allowWrite || matrixData.readOnly)
                        classesToAdd += " noWrite";
                    if (options.cellClick)
                        classesToAdd += " clickable";
                    let handled = false;
                    if (options.hasCustomCellRenderer)
                        handled = options.cellRenderFunc(rowIdx, col, td, value, matrixData);
                    if (handled === false)
                        Matrix.GetRenderFunc($this)(rowIdx, col, td, value, matrixData);
                }
                if (classesToAdd.length > 0)
                    td.className += classesToAdd;
                return td;
            },
            rowHeaders(idx) {
                const matrixData = Matrix.getMatrixData($this);
                const hotInstance = Matrix.getHandsonTableInstance($this);
                const rowElem = matrixData.dfsIndexMap[hotInstance.toPhysicalRow(idx)];
                const nestingDepthClass = rowElem.isLeaf ? "depth-leaf" : "depth-" + rowElem.nestingDepth.toString();
                let expandIcon;
                if (rowElem.isLeaf)
                    expandIcon = "<span class='expander leaf'></span>";
                else
                    expandIcon = "<span class='expander " + (rowElem.expanded ? "open" : "closed") + "'></span>";
                let cssClasses = "matrixNodeText " + nestingDepthClass;
                if (rowElem.lastClicked)
                    cssClasses += " lastClicked";
                if (rowElem.deleted)
                    cssClasses += " deleted";
                if (rowElem.clickable) {
                    cssClasses += " clickableRow";
                    if (rowElem.selectable) {
                        cssClasses += " selectableRow";
                        if (rowElem.isSelected)
                            cssClasses += " selected";
                    }
                    else
                        cssClasses += " linkRow";
                }
                let s = "<div class='" + cssClasses + "'>"
                    + expandIcon
                    + "<img class='matrixNodeIcon' src='" + Utilities_1.synUtil.getWSUrl("Icon") + rowElem.icon + "/16'>"
                    + rowElem.name
                    + "</div>";
                if (!rowElem.isRoot) {
                    if (rowElem.hasSuccessors)
                        s = "<div class='matrixNodeContCorner " + nestingDepthClass + "'></div>" + s;
                    else
                        s = "<div class='matrixNodeEndCorner " + nestingDepthClass + "'></div>" + s;
                    let curNode = rowElem.parent;
                    while (curNode != undefined && !curNode.isRoot) {
                        if (curNode.hasSuccessors)
                            s = "<div class='matrixNodeParentContCorner " + nestingDepthClass + "'></div>" + s;
                        else
                            s = "<div class='matrixNodeCorner " + nestingDepthClass + "'></div>" + s;
                        curNode = curNode.parent;
                    }
                }
                return s;
            },
            colHeaders(idx) {
                const matrixData = Matrix.getMatrixData($this);
                if (idx >= matrixData.columns.length)
                    return undefined;
                const col = matrixData.columns[idx];
                if (col.visible) {
                    const name = kendo.htmlEncode(matrixData.columns[idx].name);
                    if (col.clickable) {
                        let cssClasses = "clickableCol";
                        if (col.selectable)
                            cssClasses += " selectableCol";
                        else
                            cssClasses += " linkCol";
                        if (col.isSelected)
                            cssClasses += " selected";
                        return "<span title='" + name + "' class='" + cssClasses + "'>" + name + "</span>";
                    }
                    return "<span title='" + name + "'>" + name + "</span>";
                }
                return undefined;
            },
        });
        if (options.expandAllNodes)
            Matrix.expandAll($this, md);
        else
            Matrix.collapseRoots($this, md);
    }
    static initFieldPane($this) {
        Matrix.initTagDropdown($this);
        Matrix.initRowSearchBox($this);
        Matrix.initColumnSearchBox($this);
        $this.find(".fieldPane").removeClass("uninitialized");
    }
    static initTagDropdown($this) {
        const matrixData = Matrix.getMatrixData($this);
        const $fieldWrapper = $this.find(".fieldWrapper");
        if (matrixData.tagsEnabled) {
            const chooseTagString = Matrix.getMatrixStringValue("matrixchoosetag", matrixData.matrixId);
            let select = "<select class='tagDropDown cornerInput" + (matrixData.selectedTag ? "" : " noValue") + "'>";
            let selectedTagIdx = $.inArray(matrixData.selectedTag, matrixData.allTags);
            if (matrixData.selectedTag) {
                if (selectedTagIdx < 0) {
                    selectedTagIdx = 0;
                    matrixData.selectedTag = matrixData.allTags[0];
                }
            }
            else
                matrixData.selectedTag = "";
            if (!matrixData.heavy)
                select += "<option class='empty' value=''" + (matrixData.selectedTag ? "" : " selected data-default") + ">" + chooseTagString + "</option>";
            for (let i = 0; i < matrixData.allTags.length; ++i) {
                const curTag = matrixData.allTags[i];
                select += "<option" + (i === selectedTagIdx ? " selected='selected'" : "") + " value='" + curTag + "'>" + kendo.htmlEncode(curTag) + "</option>";
            }
            select += "</select>";
            const updateWithTag = function () {
                const val = $(this).val();
                if (val)
                    $(this).removeClass("noValue");
                else
                    $(this).addClass("noValue");
                const oldVal = matrixData.selectedTag;
                matrixData.selectedTag = val;
                if (matrixData.selectedTag !== oldVal) {
                    const hot = Matrix.getHandsonTableInstance($this);
                    hot.deselectCell();
                    Matrix.getMatrix($this, matrixData.matrixId, val, (newMatrixData) => {
                        $this.data("matrixData", newMatrixData);
                        const synData = $this.data("synMatrix");
                        hot.updateSettings({
                            data: newMatrixData.getTabularData(),
                            colWidths(index) {
                                if (index === newMatrixData.columns.length)
                                    return (synData.colHeaderSize + synData.colWidth) / Math.SQRT2;
                                return synData.colWidth;
                            }
                        });
                        hot.render();
                        Matrix.collapseRoots($this, newMatrixData);
                    });
                }
            };
            const $select = $(select)
                .on("click change", updateWithTag)
                .on("blur", updateWithTag);
            $fieldWrapper.append($select);
        }
    }
    static initRowSearchBox($this) {
        const $fieldWrapper = $this.find(".fieldWrapper");
        const $input = $("<input>")
            .addClass("autoComplete cornerInput rowSearch")
            .attr({
            "type": "text",
            "autocapitalize": "none",
            "placeholder": Matrix.getRowPlaceholder($this, Matrix.getMatrixData($this))
        })
            .appendTo($fieldWrapper)
            .blur(function () {
            window.setTimeout(() => { Matrix.updateSearchBoxPlaceholders($this, Matrix.getMatrixData($this)); }, 1000);
        })
            .autocomplete({
            minLength: 2,
            source(request, response) {
                const term = request.term;
                const mapRowIds = {};
                const results = [];
                const matrixData = Matrix.getMatrixData($this);
                for (let i = 0; i < matrixData.rowCount; ++i) {
                    const cur = matrixData.dfsIndexMap[i];
                    if (mapRowIds[cur.id])
                        continue;
                    if (cur.name.toLowerCase().indexOf(term.toLowerCase()) >= 0) {
                        results.push(cur);
                        mapRowIds[cur.id] = true;
                    }
                }
                results.sort((r1, r2) => r1.name.localeCompare(r2.name));
                response(results);
            },
            select(event, ui) {
                $input.blur();
                window.setTimeout(() => {
                    const matrixData = Matrix.getMatrixData($this);
                    const selectedItem = ui.item;
                    const items = [ui.item];
                    if (selectedItem.isLeaf) {
                        for (let i = 0; i < matrixData.rowCount; ++i) {
                            const curRow = matrixData.dfsIndexMap[i];
                            if (curRow.id === selectedItem.id && curRow.parentPath !== selectedItem.parentPath)
                                items.push(curRow);
                        }
                    }
                    for (const item of items) {
                        let curNode = item;
                        while (curNode) {
                            Matrix.collapseToggleCore($this, matrixData, curNode, true, false);
                            curNode = curNode.parent;
                        }
                    }
                    Matrix.collapseAllButThis($this, matrixData, items);
                    let physicalRowIndex = 0;
                    for (let i = 0; i < matrixData.rowCount; ++i) {
                        const curRow = matrixData.dfsIndexMap[i];
                        if (curRow.id === items[0].id) {
                            physicalRowIndex = i;
                            break;
                        }
                    }
                    const hot = Matrix.getHandsonTableInstance($this);
                    let selectedColIdx = 0;
                    if (matrixData.colIdHighlightedForSearch) {
                        const colIdx = matrixData.getColumnIndexForId(matrixData.colIdHighlightedForSearch);
                        const visualColIdx = hot.toVisualColumn(colIdx);
                        if (visualColIdx != undefined)
                            selectedColIdx = colIdx;
                    }
                    const visualRowIdx = hot.toVisualRow(physicalRowIndex);
                    const visualColIdx = hot.toVisualColumn(selectedColIdx);
                    hot.scrollViewportTo(visualRowIdx /*+ Math.floor((1 / Matrix.RowHeight) * visualRowIdx)*/, visualColIdx);
                    Matrix.unhighlightAll($this, CellHighlightReason.RowOrColumnSearch);
                    matrixData.rowIdHighlightedForSearch = items[0].id;
                    matrixData.colIdHighlightedForSearch = matrixData.columns[selectedColIdx].id;
                    Matrix.updateSearchBoxPlaceholders($this, matrixData);
                    window.setTimeout(() => { Matrix.highlightCell($this, visualRowIdx, visualColIdx, true, CellHighlightReason.RowOrColumnSearch); }, 250);
                }, 0);
            }
        });
        $input.data("uiAutocomplete")._renderItemData = function (ul, item) {
            const term = $input.data("uiAutocomplete").element.val();
            const regex = new RegExp(term.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&"), "ig");
            const li = $("<li class='ui-autocomplete-item'></li>").data("ui-autocomplete-item", item);
            const a = $("<a></a>").appendTo(li);
            a.html(kendo.htmlEncode(item.name).replace(regex, "<strong>$&</strong>"));
            ul.append(li);
        };
        $input.data("uiAutocomplete")._renderMenu = function (ul, items) {
            const that = this;
            $.each(items, (index, item) => that._renderItemData(ul, item));
            ul[0].style.setProperty("z-index", "20000", "important");
        };
    }
    static initColumnSearchBox($this) {
        const $fieldPane = $this.find(".fieldWrapper");
        const $input = $("<input>")
            .addClass("autoComplete cornerInput columnSearch")
            .attr({
            "type": "text",
            "autocapitalize": "none",
            "placeholder": Matrix.getColumnPlaceholder($this, Matrix.getMatrixData($this))
        })
            .appendTo($fieldPane)
            .blur(function () {
            // $input.attr("placeholder", $input.attr("data-oldplaceholder"))
            //    .removeAttr("data-oldplaceholder");
        })
            .focus(function () {
            // $input.attr("data-oldplaceholder", $input.attr("placeholder"))
            //    .removeAttr("placeholder");
        })
            .autocomplete({
            minLength: 2,
            source(request, response) {
                response($.grep(Matrix.getMatrixData($this).columns, (col) => col.name.toLowerCase().indexOf(request.term.toLowerCase()) >= 0));
            },
            select(event, ui) {
                $input.text("").blur();
                window.setTimeout(() => {
                    const item = ui.item;
                    const matrixData = Matrix.getMatrixData($this);
                    let colIdx = 0;
                    for (let i = 0; i < matrixData.columns.length; ++i) {
                        if (matrixData.columns[i].id === item.id) {
                            colIdx = i;
                            break;
                        }
                    }
                    const hot = Matrix.getHandsonTableInstance($this);
                    let visualRowIdx = 0;
                    if (matrixData.rowIdHighlightedForSearch) {
                        const rowIndexes = matrixData.getRowIndexesForId(matrixData.rowIdHighlightedForSearch);
                        if (rowIndexes.length) {
                            const idxTmp = hot.toVisualRow(rowIndexes[0]);
                            if (idxTmp != undefined)
                                visualRowIdx = idxTmp;
                        }
                    }
                    const visualColIdx = hot.toVisualColumn(colIdx);
                    hot.scrollViewportTo(visualRowIdx, visualColIdx);
                    Matrix.unhighlightAll($this, CellHighlightReason.RowOrColumnSearch);
                    matrixData.rowIdHighlightedForSearch = matrixData.dfsIndexMap[visualRowIdx].id;
                    matrixData.colIdHighlightedForSearch = item.id;
                    Matrix.updateSearchBoxPlaceholders($this, matrixData);
                    window.setTimeout(() => { Matrix.highlightCell($this, visualRowIdx, visualColIdx, true, CellHighlightReason.RowOrColumnSearch); }, 250);
                }, 0);
            }
        });
        $input.data("uiAutocomplete")._renderItemData = function (ul, item) {
            const term = $input.data("uiAutocomplete").element.val();
            const regex = new RegExp(term.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&"), "ig");
            const li = $("<li class='ui-autocomplete-item'></li>").data("ui-autocomplete-item", item);
            const a = $("<a></a>").appendTo(li);
            a.html(kendo.htmlEncode(item.name).replace(regex, "<strong>$&</strong>"));
            ul.append(li);
        };
        $input.data("uiAutocomplete")._renderMenu = function (ul, items) {
            const that = this;
            $.each(items, (index, item) => that._renderItemData(ul, item));
            ul[0].style.setProperty("z-index", "20000", "important");
        };
        const $resetButton = $("<span></span>")
            .addClass("matrixResetButton")
            .text("✗")
            .on("click", () => { Matrix.unhighlightAll($this, CellHighlightReason.RowOrColumnSearch); })
            .insertAfter($input)
            .hide();
    }
    static getRowPlaceholder($this, matrixData) {
        if (matrixData.rowIdHighlightedForSearch) {
            const rowIndexes = matrixData.getRowIndexesForId(matrixData.rowIdHighlightedForSearch);
            if (rowIndexes.length) {
                const hot = Matrix.getHandsonTableInstance($this);
                if (hot.toVisualRow(rowIndexes[0]) != undefined)
                    return matrixData.dfsIndexMap[rowIndexes[0]].name;
            }
        }
        return Matrix.getMatrixStringValue("matrixsearchforrow", matrixData.matrixId);
    }
    static getColumnPlaceholder($this, matrixData) {
        if (matrixData.colIdHighlightedForSearch) {
            const colIdx = matrixData.getColumnIndexForId(matrixData.colIdHighlightedForSearch);
            if (colIdx >= 0) {
                const hot = Matrix.getHandsonTableInstance($this);
                if (hot.toVisualColumn(colIdx) != undefined)
                    return matrixData.columns[colIdx].name;
            }
        }
        return Matrix.getMatrixStringValue("matrixsearchforcol", matrixData.matrixId);
    }
    static updateSearchBoxPlaceholders($this, matrixData) {
        $this.find(".cornerInput.columnSearch").attr("placeholder", Matrix.getColumnPlaceholder($this, matrixData));
        $this.find(".cornerInput.rowSearch").attr("placeholder", Matrix.getRowPlaceholder($this, matrixData));
    }
    static unhighlightAll($this, reason) {
        if (reason === CellHighlightReason.SelectionOrHover)
            $this.find(".highlightedRow,.highlightedCol,.ht__highlight,.highlight").removeClass("highlightedRow highlightedCol ht__highlight highlight");
        else {
            $this.find(".highlightedRow_Search,.highlightedCol_Search,.ht__highlight_Search").removeClass("highlightedRow_Search highlightedCol_Search ht__highlight_Search");
            $this.find(".cornerInput.columnSearch").removeClass("hasConstraint").next(".matrixResetButton").hide();
            const matrixData = $this.data("matrixData");
            matrixData.colIdHighlightedForSearch = undefined;
            matrixData.rowIdHighlightedForSearch = undefined;
            Matrix.updateSearchBoxPlaceholders($this, matrixData);
        }
    }
    static unhighlightCell($this, visualRowIdx, visualColIdx, reason) {
        if (visualRowIdx != undefined && visualRowIdx >= 0 && visualColIdx != undefined && visualColIdx >= 0) {
            const hot = Matrix.getHandsonTableInstance($this);
            const td = hot.getCell(visualRowIdx, visualColIdx, false);
            if (td != undefined) {
                const options = $this.data("synMatrix");
                const $td = $(td);
                const colIdx = $td.index() + 1;
                const rowIdx = $td.parent().index() + 1;
                if (reason === CellHighlightReason.RowOrColumnSearch) {
                    $td.add($td.siblings("td")).removeClass("highlightedRow_Search");
                    $td.closest("tbody").children("tr").each((idx, tr) => {
                        $(tr).children("td:nth-child(" + colIdx + ")").removeClass("highlightedCol_Search");
                    });
                    const $colHeader = $td.closest(".synMatrix").find(".ht_clone_top thead tr");
                    $colHeader.children("th:nth-child(" + colIdx + ")").removeClass("ht__highlight_Search highlightedCol_Search");
                    $td.closest(".synMatrix").find(".ht_clone_left tbody tr:nth-child(" + rowIdx + ") th").removeClass("ht__highlight_Search highlightedRow_Search");
                }
                else {
                    if (options.hoverHighlightingMode === HighlightingMode.Full) {
                        $td.add($td.siblings("td")).removeClass("highlightedRow highlight");
                        $td.closest("tbody").children("tr").each((idx, tr) => {
                            $(tr).children("td:nth-child(" + colIdx + ")").removeClass("highlightedCol");
                        });
                    }
                    if (options.hoverHighlightingMode !== HighlightingMode.None) {
                        const $colHeader = $td.closest(".synMatrix").find(".ht_clone_top thead tr");
                        $colHeader.children("th:nth-child(" + colIdx + ")").removeClass("ht__highlight highlightedCol");
                        $td.closest(".synMatrix").find(".ht_clone_left tbody tr:nth-child(" + rowIdx + ") th").removeClass("ht__highlight highlightedRow");
                    }
                }
            }
        }
    }
    static highlightCell($this, visualRowIdx, visualColIdx, highlightDuplicates, reason) {
        if (visualRowIdx != undefined && visualColIdx != undefined) {
            const hot = Matrix.getHandsonTableInstance($this);
            const options = $this.data("synMatrix");
            const td = hot.getCell(visualRowIdx, visualColIdx, false);
            if (td != undefined) {
                const $td = $(td);
                const colIdx = $td.index() + 1;
                const rowIdx = $td.parent().index() + 1;
                const suffix = (reason === CellHighlightReason.RowOrColumnSearch ? "_Search" : "");
                if (options.hoverHighlightingMode === HighlightingMode.Full) {
                    $td.add($td.siblings("td")).addClass("highlightedRow" + suffix);
                    $td.closest("tbody").children("tr").each((idx, tr) => {
                        $(tr).children("td:nth-child(" + colIdx + ")").addClass("highlightedCol" + suffix);
                    });
                }
                if (options.hoverHighlightingMode !== HighlightingMode.None) {
                    const $colHeader = $td.closest(".synMatrix").find(".ht_clone_top thead tr");
                    $colHeader.children("th:nth-child(" + colIdx + ")").addClass("ht__highlight" + suffix + " highlightedCol" + suffix);
                    $td.closest(".synMatrix").find(".ht_clone_left tbody tr:nth-child(" + rowIdx + ") th").addClass("ht__highlight" + suffix + " highlightedRow" + suffix);
                }
                if (reason === CellHighlightReason.RowOrColumnSearch)
                    $this.find(".cornerInput.columnSearch").addClass("hasConstraint").next(".matrixResetButton").show();
            }
            if (highlightDuplicates) {
                const matrixData = Matrix.getMatrixData($this);
                const physicalRowIdx = hot.toPhysicalRow(visualRowIdx);
                const rowIndexes = matrixData.getRowIndexesForId(matrixData.dfsIndexMap[physicalRowIdx].id);
                for (const curPhysicalRowIdx of rowIndexes) {
                    if (curPhysicalRowIdx !== physicalRowIdx) {
                        const curVisualRowIdx = hot.toVisualRow(curPhysicalRowIdx);
                        if (curVisualRowIdx != undefined)
                            Matrix.highlightCell($this, curVisualRowIdx, visualColIdx, false, reason);
                    }
                }
            }
        }
    }
    static restoreSearchHighlighting($this) {
        const matrixData = $this.data("matrixData");
        if (matrixData.rowIdHighlightedForSearch && matrixData.colIdHighlightedForSearch) {
            const matchingRowIndexes = matrixData.getRowIndexesForId(matrixData.rowIdHighlightedForSearch);
            const matchingColIdx = matrixData.getColumnIndexForId(matrixData.colIdHighlightedForSearch);
            const hot = Matrix.getHandsonTableInstance($this);
            Matrix.updateSearchBoxPlaceholders($this, matrixData);
            let visualRowIdx;
            const visualColIdx = hot.toVisualColumn(matchingColIdx);
            if (matchingRowIndexes.length)
                visualRowIdx = hot.toVisualRow(matchingRowIndexes[0]);
            if (visualRowIdx != undefined)
                Matrix.highlightCell($this, visualRowIdx, visualColIdx, true, CellHighlightReason.RowOrColumnSearch);
        }
    }
    static cellHasPendingOperation($this, physicalRowIdx, colIdx) {
        const hotInstance = Matrix.getHandsonTableInstance($this);
        const visualRowIdx = hotInstance.toVisualRow(physicalRowIdx);
        if (visualRowIdx == undefined)
            return false;
        const td = hotInstance.getCell(visualRowIdx, colIdx, false);
        const refCountObj = $(td).data("refCountObj");
        if (!refCountObj)
            return false;
        return refCountObj.refCount > 0;
    }
    static cellWaitAnimation($td, begin) {
        Matrix.waitAnimationCore($td, begin, () => { $td.html("<i class='fa fa-spinner'></i>").addClass("waitAnimation"); }, () => {
            $td.removeClass("waitAnimation");
            $td.find("i.fa-spinner").remove();
        });
    }
    static matrixWaitAnimation($this, begin, action) {
        Matrix.waitAnimationCore($this, begin, () => { $this.append("<div class='waitOverlay'><div class='progress'><i class='fa fa-spinner'></i><div class='statusText'>" + kendo.htmlEncode(action || "") + "</div></div>"); }, () => { $this.find("div.waitOverlay").remove(); }, () => { $this.find("div.waitOverlay .statusText").text(action); });
    }
    static waitAnimationCore($elem, begin, initialize, cleanUp, update) {
        let refCountObj = $elem.data("refCountObj");
        if (begin) {
            if (!refCountObj) {
                refCountObj = new RefCountObject();
                $elem.data("refCountObj", refCountObj);
            }
            if (++refCountObj.refCount === 1)
                initialize();
            else if (update)
                update();
        }
        else {
            if (!refCountObj)
                return;
            if (--refCountObj.refCount === 0) {
                $elem.removeData("refCountObj");
                cleanUp();
            }
        }
    }
    static collapseRoots($this, matrixData) {
        $.each(matrixData.roots, (idx, root) => {
            Matrix.collapseToggleCore($this, matrixData, root, false, true);
        });
        Matrix.renderWithCollapsedRowState($this, matrixData);
    }
    static expandAll($this, matrixData) {
        $.each(matrixData.roots, (idx, root) => {
            Matrix.collapseToggleCore($this, matrixData, root, true, true);
        });
        Matrix.renderWithCollapsedRowState($this, matrixData);
    }
    static collapseAllButThis($this, matrixData, rowElements) {
        const nonCollapsibleNodes = rowElements.slice();
        for (const rowElem of rowElements) {
            let curNode = rowElem.parent;
            while (curNode != undefined) {
                nonCollapsibleNodes.push(curNode);
                curNode = curNode.parent;
            }
        }
        for (const rowElem of rowElements) {
            let curNode = rowElem;
            while (curNode != undefined) {
                const parent = curNode.parent;
                const neighbors = parent == undefined ? matrixData.roots : parent.children;
                $.each(neighbors, (idx, neighbor) => {
                    if (nonCollapsibleNodes.indexOf(neighbor) < 0)
                        Matrix.collapseToggleCore($this, matrixData, neighbor, false, true);
                });
                curNode = parent || undefined;
            }
        }
        Matrix.renderWithCollapsedRowState($this, matrixData);
    }
    static collapseToggleCore($this, matrixData, rowElem, expand, recursive) {
        if (!rowElem.isLeaf) {
            rowElem.expanded = expand;
            if (recursive)
                $.each(rowElem.children, (idx, childElem) => Matrix.collapseToggleCore($this, matrixData, childElem, expand, recursive));
        }
    }
    static renderWithCollapsedRowState($this, matrixData) {
        const hot = Matrix.getHandsonTableInstance($this);
        const trimIndexes = [];
        const untrimIndexes = [];
        const mapRefreshRows = {};
        for (let i = 0; i < matrixData.rowCount; ++i) {
            let collapse = false;
            const curRow = matrixData.dfsIndexMap[i];
            let parent = matrixData.dfsIndexMap[i].parent;
            while (parent != undefined) {
                if (!parent.expanded) {
                    collapse = true;
                    break;
                }
                parent = parent.parent;
            }
            if (collapse)
                trimIndexes.push(i);
            else {
                untrimIndexes.push(i);
                mapRefreshRows[curRow.id] = true;
            }
        }
        const plugin = hot.getPlugin("trimRows");
        plugin.trimRows(trimIndexes);
        plugin.untrimRows(untrimIndexes);
        const refreshRowIds = $.map(Object.keys(mapRefreshRows), (s) => parseInt(s, 10));
        if (refreshRowIds.length)
            hot.setDataAtCell(matrixData.getUpdateData(hot, refreshRowIds, undefined));
        hot.render();
    }
    static getMatrixData($this) {
        return $this.data("matrixData");
    }
    static GetRenderFunc($this) {
        const matrixData = Matrix.getMatrixData($this);
        switch (matrixData.cellType) {
            case 10 /*FtKey*/:
                return Matrix.FtRenderer;
            case 5 /*Bool*/:
                return Matrix.BoolRenderer;
            case 2 /*Digit*/:
                return Matrix.IntRenderer;
            case 2 /*Float*/:
                return Matrix.FloatRenderer;
            case 4 /*Date*/:
                return Matrix.DateRenderer;
            case 7 /*Time*/:
                return Matrix.TimeRenderer;
            case 8 /*DateTime*/:
                return Matrix.DateTimeRenderer;
            case 1 /*String*/:
            default:
                return Matrix.StringRenderer;
        }
    }
    static FtRenderer(physicalRowIdx, colIdx, td, value, matrixData) {
        td.innerHTML = "";
        if (value === null || value === void 0 ? void 0 : value.value) {
            const entry = matrixData.getFtEntry(value.value);
            let classesToAdd = "";
            if (entry) {
                if (entry.cssClass)
                    classesToAdd += " cssIcon " + entry.cssClass;
                else if (entry.icon) {
                    classesToAdd += " ftIcon";
                    td.innerHTML = "<img class='cellIcon' src='" + Utilities_1.synUtil.getWSUrl("Icon") + "docid=" + entry.icon + "/16'>";
                }
                else
                    td.innerHTML = entry.id.toString();
            }
            else {
                const fmt = Utilities_1.synUtil.convertFormatString(Utilities_1.synUtil.Strings.getValue("dynpftentryharddeleted"));
                td.title = kendo.format(fmt, value.value.toString());
                classesToAdd += " unknownValue";
                td.innerHTML = value.value.toString();
            }
            if (classesToAdd.length > 0)
                td.className += classesToAdd;
        }
        return true;
    }
    static BoolRenderer(rowIdx, colIdx, td, value, matrixData) {
        if (value) {
            let classesToAdd = " cssIcon";
            if (value.value === true)
                classesToAdd += " yes";
            td.className += classesToAdd;
        }
        return true;
    }
    static IntRenderer(rowIdx, colIdx, td, value, matrixData) {
        td.innerHTML = value == undefined || value.value == undefined ? "" : value.value.toString();
        return true;
    }
    static FloatRenderer(rowIdx, colIdx, td, value, matrixData) {
        td.innerHTML = value == undefined || value.value == undefined ? "" : value.value.toString();
        return true;
    }
    static DateRenderer(rowIdx, colIdx, td, value, matrixData) {
        td.innerHTML = value == undefined || value.value == undefined ? "" : value.value.toString();
        return true;
    }
    static TimeRenderer(rowIdx, colIdx, td, value, matrixData) {
        td.innerHTML = value == undefined || value.value == undefined ? "" : value.value.toString();
        return true;
    }
    static DateTimeRenderer(rowIdx, colIdx, td, value, matrixData) {
        td.innerHTML = value == undefined || value.value == undefined ? "" : value.value.toString();
        return true;
    }
    static StringRenderer(rowIdx, colIdx, td, value, matrixData) {
        td.innerHTML = value == undefined || value.value == undefined ? "" : value.value.toString();
        return true;
    }
    static setServerData($this, serverData, matrixData, forColId) {
        const synData = $this.data("synMatrix");
        matrixData.setData(synData, serverData, forColId);
        if (synData.rowClickMode !== RowClickMode.None) {
            for (const prop in matrixData.dfsIndexMap) {
                const row = matrixData.dfsIndexMap[prop];
                if (synData.rowClickMode === RowClickMode.Properties)
                    row.clickable = true;
                if (synData.rowClickMode === RowClickMode.RowSelection_OnlyLeaves)
                    row.clickable = row.selectable = row.isLeaf;
                else if (synData.rowClickMode === RowClickMode.RowSelection_All)
                    row.clickable = row.selectable = row.hasValues;
            }
        }
        if (synData.colClickMode === ColumnClickMode.ColSelection_All) {
            const mapColWithValues = {};
            for (const prop in matrixData.dfsIndexMap) {
                const row = matrixData.dfsIndexMap[prop];
                for (const prop2 in row.values) {
                    if (mapColWithValues[prop2])
                        continue;
                    const cellVal = row.values[prop2];
                    if (cellVal === null || cellVal === void 0 ? void 0 : cellVal.value)
                        mapColWithValues[prop2] = true;
                }
            }
            $.each(matrixData.columns, (idx, col) => {
                col.clickable = col.selectable = mapColWithValues[col.id] === true;
            });
        }
        else if (synData.colClickMode === ColumnClickMode.Properties || synData.colClickMode === ColumnClickMode.Callback) {
            $.each(matrixData.columns, (idx, col) => {
                col.clickable = true;
            });
        }
        Matrix.buildColumnCellLookup(matrixData, forColId);
    }
    // Builds the column-cell lookup
    static buildColumnCellLookup(matrixData, forColId) {
        const mapColumns = {};
        if (forColId != undefined) {
            const colIdx = matrixData.columns.findIndex(c => c.id === forColId);
            if (colIdx !== -1)
                mapColumns[forColId] = matrixData.columns[colIdx];
        }
        else
            for (const curCol of matrixData.columns)
                mapColumns[curCol.id] = curCol;
        for (const prop in mapColumns)
            mapColumns[prop].allCellValues = [];
        for (let i = 0; i < matrixData.rowCount; ++i) {
            const curRow = matrixData.dfsIndexMap[i];
            for (const prop in curRow.values) {
                const curColId = parseInt(prop, 10);
                if (forColId == undefined || curColId === forColId) {
                    if (typeof mapColumns[curColId] !== "undefined")
                        mapColumns[curColId].allCellValues.push(curRow.values[prop]);
                }
            }
        }
    }
    static getMatrix($this, matrixId, forTag, callback) {
        const synData = $this.data("synMatrix");
        const requestData = {};
        if (forTag)
            requestData.forTag = forTag;
        if (synData.userHierarchyStartField)
            requestData.userHierStartField = synData.userHierarchyStartField;
        if (synData.rowIds)
            requestData.rowIds = synData.rowIds;
        if (synData.colIds)
            requestData.colIds = synData.colIds;
        if (synData.contextInformation)
            requestData.contextInformation = synData.contextInformation;
        Matrix.matrixWaitAnimation($this, true, Matrix.getMatrixStringValue("matrixfetch", matrixId));
        Utilities_1.synUtil.getAJAXData({
            method: "POST",
            url: Utilities_1.synUtil.getWSUrl("MatrixStructure") + matrixId,
            requestData: JSON.stringify(requestData),
            done: (data) => {
                const roots = [];
                const columns = [];
                $.each(data.columns, (idx, colElem) => columns.push($.extend(new MatrixColumnElement(colElem.id, colElem.name, colElem.tags), colElem)));
                const mapIdToRowElem = {};
                const mapIdToParentPaths = {};
                const allNodes = [];
                for (const prop in data.rowElements) {
                    const rowId = parseInt(prop, 10);
                    const jsonElem = data.rowElements[prop];
                    const rowElem = new MatrixRowElement(rowId, jsonElem.name || kendo.format("({0})", rowId));
                    rowElem.icon = jsonElem.icon;
                    rowElem.abstract = jsonElem.abstract;
                    rowElem.allowRead = jsonElem.allowRead;
                    rowElem.allowWrite = jsonElem.allowWrite;
                    rowElem.isOrgNode = jsonElem.isOrgNode;
                    mapIdToRowElem[rowId] = rowElem;
                    mapIdToParentPaths[rowId] = jsonElem.parentPaths;
                }
                for (const prop in mapIdToRowElem) {
                    let node = mapIdToRowElem[prop];
                    for (let i = 0; i < mapIdToParentPaths[prop].length; ++i) {
                        const parentPath = mapIdToParentPaths[prop][i];
                        if (i > 0)
                            node = node.clone;
                        node.parentPath = parentPath;
                        const parentNode = mapIdToRowElem[parentPath[0]];
                        node.parent = parentNode;
                        parentNode.children.push(node);
                    }
                    allNodes.push(node);
                }
                for (let i = 0; i < allNodes.length; ++i)
                    if (allNodes[i].parent == undefined)
                        roots.push(allNodes[i]);
                const matrixData = new MatrixData(columns, roots, data.cellType, data.cellFtValues);
                matrixData.readOnly = data.readOnly || false;
                if (!matrixData.readOnly && (synData.rowClickMode === RowClickMode.RowSelection_All || synData.rowClickMode === RowClickMode.RowSelection_OnlyLeaves))
                    $.error("You cannot assign a selection-based rowClickMode for a readonly matrix.");
                if (!matrixData.readOnly && synData.colClickMode === ColumnClickMode.ColSelection_All)
                    $.error("You cannot assign a selection-based colClickMode for a readonly matrix.");
                if (synData.cellClick && !matrixData.readOnly)
                    synData.cellClick = undefined;
                matrixData.heavy = data.heavy;
                matrixData.tagsEnabled = data.tagsEnabled;
                matrixData.selectedTag = data.selectedTag;
                matrixData.allTags = data.allTags;
                if (matrixData.allTags)
                    matrixData.allTags.sort((t1, t2) => t1.localeCompare(t2));
                if (synData.initiallySelectedTag) {
                    matrixData.selectedTag = synData.initiallySelectedTag;
                    synData.initiallySelectedTag = "";
                }
                matrixData.matrixId = data.matrixId;
                $this.trigger("structureReceived");
                Matrix.fetchMatrixData($this, matrixId, matrixData, undefined, forTag || matrixData.selectedTag || undefined, undefined, synData.contextInformation, (data) => {
                    matrixData.columns = matrixData.columns.filter((col) => synData.columnFilterPredicate(col, data));
                    // Set MatrixData
                    $.each(matrixData.columns, (idx, col) => { col.m_matrixData = matrixData; });
                    Matrix.setServerData($this, data, matrixData);
                    $this.trigger("dataReceived");
                    callback(matrixData);
                });
            },
            cleanUp: () => {
                Matrix.matrixWaitAnimation($this, false);
            }
        });
    }
    static fetchMatrixData($this, matrixId, matrixData, forColId, forTag, forRowIds, contextInformation, callback, cleanUpFunc) {
        let relevantRowIds;
        if (forRowIds === null || forRowIds === void 0 ? void 0 : forRowIds.length)
            relevantRowIds = forRowIds;
        else
            relevantRowIds = matrixData.getRowIds();
        const requestData = {
            rowIds: relevantRowIds
        };
        if (forColId != undefined)
            requestData.colId = forColId;
        if (contextInformation != undefined)
            requestData.contextInformation = contextInformation;
        else if (forTag != undefined)
            requestData.forTag = forTag;
        if (forColId == undefined)
            Matrix.matrixWaitAnimation($this, true, Matrix.getMatrixStringValue("matrixfetchdata", matrixId));
        const synData = $this.data("synMatrix");
        if (synData.userHierarchyStartField)
            requestData.userHierarchyStartField = synData.userHierarchyStartField;
        if (synData.colIds)
            requestData.colIds = synData.colIds;
        matrixData.beginRequest();
        Utilities_1.synUtil.getAJAXData({
            url: Utilities_1.synUtil.getWSUrl("MatrixData") + matrixId,
            method: "POST",
            requestData: JSON.stringify(requestData),
            done: (data) => {
                for (let i = 0; i < data.length; ++i)
                    for (const prop in data[i].values)
                        data[i].values[prop].value = Matrix.jsonToCellValue(data[i].values[prop].value, matrixData.cellType);
                if (callback)
                    callback(data);
            },
            cleanUp() {
                if (forColId == undefined)
                    Matrix.matrixWaitAnimation($this, false);
                matrixData.endRequest();
                if (cleanUpFunc)
                    cleanUpFunc();
            }
        });
    }
    static updateCellValue($this, matrixData, rowId, colId, newValue) {
        const synData = $this.data("synMatrix");
        const hotInstance = Matrix.getHandsonTableInstance($this);
        const visualColIdx = hotInstance.toVisualColumn(matrixData.getColumnIndexForId(colId));
        let $tds = $();
        const rowQueue = matrixData.getRowsForRowId(rowId);
        let physicalRowIndexes;
        while (rowQueue.length > 0) {
            const curRow = rowQueue.shift();
            if (curRow)
                physicalRowIndexes = matrixData.getRowIndexesForId(curRow.id);
            if (curRow === null || curRow === void 0 ? void 0 : curRow.isLeaf) {
                for (let i = 0; i < physicalRowIndexes.length; ++i) {
                    const visualRowIdx = hotInstance.toVisualRow(physicalRowIndexes[i]);
                    if (visualRowIdx != undefined && visualRowIdx >= 0)
                        $tds = $tds.add($(hotInstance.getCell(visualRowIdx, visualColIdx, false)));
                }
            }
            else if (curRow) {
                const visualRowIdx = hotInstance.toVisualRow(physicalRowIndexes[0]);
                if (visualRowIdx != undefined && visualRowIdx >= 0)
                    $tds = $tds.add($(hotInstance.getCell(visualRowIdx, visualColIdx, false)));
                $.each(curRow.children, (idx, childRow) => {
                    rowQueue.push(childRow);
                });
            }
        }
        if ($tds.length === 0)
            return;
        Matrix.cellWaitAnimation($tds, true);
        Matrix.setMatrixData($this, matrixData.matrixId, matrixData, rowId, colId, newValue, () => {
            Matrix.cellWaitAnimation($tds, true);
            Matrix.fetchMatrixData($this, matrixData.matrixId, matrixData, colId, undefined, matrixData.getEnvironmentForRowId(rowId), synData.contextInformation, (serverData) => {
                Matrix.setServerData($this, serverData, matrixData, colId);
                const updateData = matrixData.getUpdateData(hotInstance, undefined, colId);
                hotInstance.setDataAtCell(updateData);
                hotInstance.render();
            }, () => { Matrix.cellWaitAnimation($tds, false); });
        }, () => { Matrix.cellWaitAnimation($tds, false); });
    }
    static setMatrixData($this, matrixId, matrixData, rowId, colId, value, callback, cleanUp) {
        const synData = $this.data("synMatrix");
        matrixData.beginRequest();
        const requestData = {
            rowId: rowId.toString(),
            colId: colId.toString(),
            value: JSON.stringify(Matrix.cellValueToJson(value, matrixData.cellType))
        };
        if (synData.rowIds)
            requestData.rowIds = synData.rowIds;
        if (synData.colIds)
            requestData.colIds = synData.colIds;
        Utilities_1.synUtil.getAJAXData({
            url: Utilities_1.synUtil.getWSUrl("MatrixData") + matrixId + "/setValue/",
            method: "POST",
            requestData,
            done: callback,
            cleanUp() {
                matrixData.endRequest();
                cleanUp();
            }
        });
    }
    static cellValueToJson(cellValue, cellType) {
        switch (cellType) {
            case 1 /*String*/:
            case 2 /*Digit*/:
            case 3 /*Float*/:
            case 10 /*FTKey*/:
                return cellValue;
            case 5 /*Bool*/:
                return cellValue;
            case 4 /*Date*/:
                return Utilities_1.synUtil.dateToJson(cellValue);
            case 7 /*Time*/:
                return Utilities_1.synUtil.timeToJson(cellValue);
            case 8 /*DateTime*/:
                return Utilities_1.synUtil.dateTimeToJson(cellValue);
            default:
                throw new Error("Invalid cellType: " + cellType);
        }
    }
    static jsonToCellValue(cellValue, cellType) {
        switch (cellType) {
            case 1 /*String*/:
            case 2 /*Digit*/:
            case 3 /*Float*/:
            case 5 /*Bool*/:
            case 10 /*FTKey*/:
                return cellValue;
            case 4 /*Date*/:
                return Utilities_1.synUtil.jsonToDate(cellValue);
            case 7 /*Time*/:
                return Utilities_1.synUtil.jsonToTime(cellValue);
            case 8 /*DateTime*/:
                return Utilities_1.synUtil.jsonToDateTime(cellValue);
            default:
                throw new Error("Invalid cellType: " + cellType);
        }
    }
    static getHandsonTableInstance($this) {
        return $this.children(".matrixPane").handsontable("getInstance") || undefined;
    }
}
/**
* Must match LESS row height definition in Matrix.less
*/
Matrix.RowHeight = 20;
(($) => {
    $.fn.synMatrix = function (method) {
        if (Matrix[method])
            return Matrix[method].apply(undefined, [this].concat(Array.prototype.slice.call(arguments, 1)));
        else if (typeof method === "object" || !method)
            return Matrix.init(this, arguments[0]);
        else
            $.error("Method " + method + " does not exist on jQuery.synMatrix");
    };
})(jQuery);
